module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Laurie Friedman, Jennifer Kalis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Jennifer Kalis")]), _vm._v(" is the illustrator of several "), _c('B', [_vm._v("Mallory")]), _vm._v(" books including "), _c('I', [_vm._v("Mallory's Super Sleepover")]), _vm._v(", "), _c('I', [_vm._v("Mallory in the Spotlight")]), _vm._v(", and "), _c('I', [_vm._v("Mallory Goes Green")]), _vm._v("! She lives in Ohio.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FxI9N9/tc-custom/9781467727471.jpg?1718162162997",
      "alt": "This image is the cover for the book Mallory and Mary Ann Take New York, Mallory"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mallory and Mary Ann Take New York, Mallory\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("START SPREADING THE NEWS . . . Mallory and Mary Ann are headed to New York. They've got sights to see! The Empire State Building. The Statue of Liberty. Times Square. Central Park. But they also have a problem to solve. Only one of them is invited to appear on their favorite TV show, "), _c('i', [_vm._v("Fashion Fran")]), _vm._v(". How can two best friends find a way to share a spotlight with room for only one?")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Lerner Publishing Group\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0